import { ArrowPrevIcon } from '@/components/icons/arrow-prev';
import { PBMSalePrice } from '@/types';
import SquaredBox from '@/components/ui/squared-box';
import Header from './pbm-header';
import { PbmEmbeddedShell } from './pbm-embedded-shell';

export default function BoxConfirmation({
  promotion,
  onBack,
  embedded,
}: Readonly<{
  promotion: PBMSalePrice | null;
  onBack?: () => void;
  embedded?: boolean;
}>) {
  const inner = (
    <>
      <div className="flex flex-grow flex-col items-center justify-center gap-4">
        {promotion && (
          <p className="text-center text-accent">
            {promotion.quantity} unid cada por R${promotion.price.toFixed(2)}
          </p>
        )}
        <div className="w-3/4 rounded-full bg-color-primary py-1 text-center">
          <p className="text-lg text-white">Benefício Aplicado</p>
        </div>
      </div>
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          className="mt-2 flex items-center gap-1 self-start text-sm font-medium text-accent"
        >
          <ArrowPrevIcon className="h-5 w-5" />
          Voltar
        </button>
      )}
    </>
  );

  if (embedded) {
    return <PbmEmbeddedShell className="border-dashed">{inner}</PbmEmbeddedShell>;
  }

  return (
    <SquaredBox>
      <Header />
      <SquaredBox.Content className="flex flex-grow flex-col p-6">{inner}</SquaredBox.Content>
    </SquaredBox>
  );
}
